    export default function useUser() {
        if (!window.GNE?.user) {
            return {
                isAuthenticated: false,
                user: null,
            }
        }
        return {
            isAuthenticated: true,
            user: {
                id: window.GNE.user.id,
                email: window.GNE.user.email,
                accountNumber: window.GNE.user.accountNumber,
                accountNumberWithStoreId: window.GNE.user.accountNumberWithStoreId,
                companyName: window.GNE.user.companyName,
                name: window.GNE.user.name,
            },
        }
    }